<div #container class="approve-class component-wrap">
  <mat-label
    #labelContainer
    (click)="toggleTooltip(tooltip)"
    class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ft-label"
    [title]="componentDefinition?.label">
    {{componentDefinition?.label}}
  </mat-label>

  <div class="labelToolTipContainer"
       #tooltip="matTooltip"
       matTooltip="{{componentDefinition.label}}"
       [matTooltipDisabled]="showToolTip(tooltip, container, labelContainer)">
  </div>
  <div class="checkbox-wrap">
    <mat-checkbox
      color="primary"
      [id]="componentDefinition?.name + document.documentId"
      [name]="componentDefinition?.name"
      [formControl]="formControl"
    >
      <span>{{approveUserMsg}}</span>
    </mat-checkbox>
  </div>
</div>
<ft-validation-display class="approve-validation-class" [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
